export const communicationPreferences = [
  { id: 'video', value: 'video', label: 'Video' },
  { id: 'chat', value: 'chat', label: 'Chat' },
  { id: 'email', value: 'email', label: 'Email' },
  { id: 'phone', value: 'phone', label: 'Phone' },
]; 